<script>
import WorkItemDetail from '~/work_items/components/work_item_detail.vue';
import glFeatureFlagsMixin from '~/vue_shared/mixins/gl_feature_flags_mixin';
import AgentPlan from 'ee/work_items/components/agent_plan/agent_plan.vue';

export default {
  name: 'WorkItemDetailEE',
  components: {
    WorkItemDetail,
    AgentPlan,
  },
  mixins: [glFeatureFlagsMixin()],
  inheritAttrs: false,
  methods: {
    // TODO: use workItem once the BE is ready
    // eslint-disable-next-line no-unused-vars
    isAvailable(workItem) {
      return this.glFeatures.agentPlan;
    },
  },
};
</script>

<template>
  <work-item-detail v-bind="$attrs" v-on="$listeners">
    <template #widgets="{ workItem }">
      <agent-plan
        v-if="isAvailable(workItem)"
        :work-item-id="workItem.id"
        :can-update="workItem.userPermissions?.updateWorkItem"
        :content="''"
        @save="() => {}"
      />
    </template>
  </work-item-detail>
</template>
